// Products a client can apply for — insurance and investment/registered accounts.
// `value` is the slug stored on the case (case.products_applied); labels are shown in UI/PDF.
export const PRODUCT_GROUPS = [
  {
    category: 'Insurance',
    options: [
      { value: 'term_life', label: 'Term Life' },
      { value: 'whole_life', label: 'Whole Life' },
      { value: 'universal_life', label: 'Universal Life' },
      { value: 'critical_illness', label: 'Critical Illness' },
      { value: 'disability', label: 'Disability' },
      { value: 'segregated_fund', label: 'Segregated Fund' },
      { value: 'other_insurance', label: 'Other (Insurance)' },
    ],
  },
  {
    category: 'Investment / Registered',
    options: [
      { value: 'tfsa', label: 'TFSA' },
      { value: 'rrsp', label: 'RRSP' },
      { value: 'rrif', label: 'RRIF' },
      { value: 'fhsa', label: 'FHSA' },
      { value: 'rdsp', label: 'RDSP' },
      { value: 'resp', label: 'RESP' },
      { value: 'lira', label: 'LIRA' },
      { value: 'annuity', label: 'Annuity' },
      { value: 'non_registered', label: 'Non-Registered' },
      { value: 'other_investment', label: 'Other (Investment)' },
    ],
  },
];

export const INVESTMENT_PRODUCTS = [
  'tfsa', 'rrsp', 'rrif', 'fhsa', 'rdsp', 'resp', 'lira', 'annuity', 'non_registered', 'other_investment',
];

export const isInvestmentSelection = (products = []) =>
  (products || []).some((p) => INVESTMENT_PRODUCTS.includes(p));

export const PRODUCT_LABELS = PRODUCT_GROUPS.reduce((acc, g) => {
  g.options.forEach((o) => { acc[o.value] = o.label; });
  return acc;
}, {});
